
import { helpers, required, minValue, maxValue } from "@vuelidate/validators";
import type { Ref } from "vue";
import type { HypertensionReading } from "@/entities/conditions";

export default (currentReading: Ref<HypertensionReading | null>) => ({
    readingdate: {
        required: helpers.withMessage("The reading date field is required.",
            required),
    },
    diastolic: {
        required: helpers.withMessage("The Diastolic field is required.",
            required),
        maxValue: helpers.withMessage("The Diastolic field must be 999 or less.",
            maxValue(999)),
        minValue: helpers.withMessage("The Diastolic field must be 0 or more.",
            minValue(0)),
    },
    systolic: {
        required: helpers.withMessage("The Systolic field is required.",
            required),
        maxValue: helpers.withMessage("The Systolic field must be 999 or less.",
            maxValue(999)),
        minValue: helpers.withMessage("The Systolic field must be 0 or more.",
            minValue(0)),
        greaterThanDiastolic: helpers.withMessage("Systolic must be greater than Diastolic.",
            (value: number) => {
                const diastolic = currentReading.value?.diastolic;
                if (!helpers.req(value) || diastolic === null || diastolic === undefined) {
                    return true;
                }
                return value > diastolic;
            }),

    },
});
